import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useUpdateDatasetDataModel = (category, { code, name }) => {
  const handler = useDispatch();
  return useCallback(({ dataModelCode }) => handler({
    type: actions.UPDATE_DATASET_DATA_MODEL, category, code, dataModelCode, name,
  }), [category, code, name]);
};

export default {
  useUpdateDatasetDataModel,
};
